import { defineStore } from 'pinia';

export const useMapStore = defineStore('map', {
  state: () => ({
    mapIsOpen: false,
    selectedUniversity: null,
    /** Property id highlighted from list hover in Grid/Split side map */
    hoveredPropertyId: null,
  }),

  actions: {
    toggleMap() {
      this.mapIsOpen = !this.mapIsOpen;
    },
    openMap() {
      this.mapIsOpen = true;
    },
    closeMap() {
      this.mapIsOpen = false;
    },
    setSelectedUniversity(university) {
      this.selectedUniversity = university;
    },
    setHoveredProperty(propertyId) {
      this.hoveredPropertyId =
        propertyId === null || propertyId === undefined
          ? null
          : propertyId;
    },
    clearHoveredProperty() {
      this.hoveredPropertyId = null;
    },
  },
});
